import { array, dateTime, defineAction, enumerated, number, object, string } from '~/prix'
import entrepreneurAgentRequestHistoryAction from './entrepreneurAgentRequestHistory.action.json' assert { type: 'json' }

const entrepreneurAgentRequestHistoryDefinition = defineAction({
  ...entrepreneurAgentRequestHistoryAction,
  userActivityLogInput: 'omit' as const,
  operation: 'read' as const,
  input: object({
    entrepreneurCpf: string(),
    startIndex: number().isOptional(),
    endIndex: number().isOptional(),
  }),
  output: object({
    totalCount: number(),
    requests: array(
      object({
        requestId: string(),
        state: enumerated({
          searchingAgents: 'searching_agents',
          agentAccepted: 'agent_accepted',
          agentArrived: 'agent_arrived',
          inAttendance: 'in_attendance',
          allAgentsRefused: 'all_agents_refused',
          noAgentsAvailable: 'no_agents_available',
          done: 'done',
          canceled: 'canceled',
          unknown: 'unknown',
        }),
        createdAt: dateTime(),
        closedAt: dateTime().isOptional(),
        addressDisplay: string().isOptional(),
        companyName: string().isOptional(),
        serviceReason: string().isOptional(),
        canceledBy: enumerated({
          entrepreneur: 'entrepreneur',
          agent: 'agent',
          system: 'system',
        }).isOptional(),
      }),
    ),
  }),
})

export default entrepreneurAgentRequestHistoryDefinition
